// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-item {
  align-items: flex-start;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  justify-content: flex-start;
  margin: 0 0 20px 0;
  padding: 10px;
  width: 100%;
}

.list-item.detailed {
  margin: 0 10px 20px 10px;
  max-width: 240px;
}

.list-item.detailed .item-header {
  border-left: 5px solid black;
  padding-left: 10px;
}

.item-title {
  color: black;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  margin: 5px 0 5px;
  text-decoration: none;
}
.item-title:hover {
  opacity: 0.5;
}

.item-subtitle {
  margin: 5px 0 10px;
}

.item-subtitle span {
  font-weight: bold;
}

.item-action {
  display: flex;
  justify-content: flex-end;
  margin: 5px 0 10px;
  width: 100%;
}

.item-action a {
  color: black;
  text-decoration: underline;
}

.item-action a:hover {
  text-decoration: none;
}
.item-footer {
  display: flex;
  flex-direction: column;
  align-self: unset;
  font-size: 14px;
  text-align: right;
  justify-content: flex-end;
  width: 100%;
  flex: 1 1;
}

.item-footer span {
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/List/List.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".list-item {\n  align-items: flex-start;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n  justify-content: flex-start;\n  margin: 0 0 20px 0;\n  padding: 10px;\n  width: 100%;\n}\n\n.list-item.detailed {\n  margin: 0 10px 20px 10px;\n  max-width: 240px;\n}\n\n.list-item.detailed .item-header {\n  border-left: 5px solid black;\n  padding-left: 10px;\n}\n\n.item-title {\n  color: black;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 5px 0 5px;\n  text-decoration: none;\n}\n.item-title:hover {\n  opacity: 0.5;\n}\n\n.item-subtitle {\n  margin: 5px 0 10px;\n}\n\n.item-subtitle span {\n  font-weight: bold;\n}\n\n.item-action {\n  display: flex;\n  justify-content: flex-end;\n  margin: 5px 0 10px;\n  width: 100%;\n}\n\n.item-action a {\n  color: black;\n  text-decoration: underline;\n}\n\n.item-action a:hover {\n  text-decoration: none;\n}\n.item-footer {\n  display: flex;\n  flex-direction: column;\n  align-self: unset;\n  font-size: 14px;\n  text-align: right;\n  justify-content: flex-end;\n  width: 100%;\n  flex: 1;\n}\n\n.item-footer span {\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
